module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Armchair-a34d53db7b788ffacbeacda8813fbabf.svg";